// import { useState, useRef, useEffect, useCallback } from "react";
// import { ChevronLeft, ChevronRight, X } from "lucide-react";
// import "./css/TempFun.css";
// import { findCoreInitiativeById } from "../features/PublicAPIsService";
// import { useDispatch, useSelector } from "react-redux";

// function useDebouncedResize(debounceTime = 150) {
//   const [windowSize, setWindowSize] = useState({
//     width: typeof window !== "undefined" ? window.innerWidth : 1200,
//     height: typeof window !== "undefined" ? window.innerHeight : 800,
//   });

//   useEffect(() => {
//     let timeoutId;

//     const handleResize = () => {
//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(() => {
//         setWindowSize({
//           width: window.innerWidth,
//           height: window.innerHeight,
//         });
//       }, debounceTime);
//     };

//     window.addEventListener("resize", handleResize, { passive: true });

//     return () => {
//       window.removeEventListener("resize", handleResize);
//       clearTimeout(timeoutId);
//     };
//   }, [debounceTime]);

//   return windowSize;
// }

// export default function TempFun({ data }) {
//   const dispatch = useDispatch();

//   const [yearIndex, setYearIndex] = useState(0);
//   const [monthIndex, setMonthIndex] = useState(0);
//   const [cardIndex, setCardIndex] = useState(0);
//   const [selectedCard, setSelectedCard] = useState(null);
//   const [showDetailSlider, setShowDetailSlider] = useState(false);

//   const { coreInitiativeDetail } = useSelector(
//     (state) => state?.PublicAPIsService ?? {}
//   );

//   const { width } = useDebouncedResize(200);
//   const isMobile = width < 768;

//   const yearLineRef = useRef(null);
//   const yearDotsRef = useRef([]);
//   const progressRef = useRef(null);
//   const timeLineDetailSliderRef = useRef(null);


//   const rafId = useRef(null);

//   const year = data[yearIndex];
//   const month = year.months[monthIndex];
//   const cards = month.cards;
//   const card = cards[cardIndex];
//   const updateProgressBar = useCallback(() => {
//     if (rafId.current) cancelAnimationFrame(rafId.current);

//     rafId.current = requestAnimationFrame(() => {
//       const dots = yearDotsRef.current;
//       const progress = progressRef.current;
//       const track = progress?.parentElement;

//       if (!dots.length || !progress || !track) return;

//       const first = dots[0];
//       const active = dots[yearIndex];
//       if (!first || !active) return;

//       const firstRect = first.getBoundingClientRect();
//       const activeRect = active.getBoundingClientRect();
//       const trackRect = track.getBoundingClientRect();

//       const firstCenter =
//         firstRect.left + firstRect.width / 2 - trackRect.left;

//       const activeCenter =
//         activeRect.left + activeRect.width / 2 - trackRect.left;

//       const newWidth = Math.max(activeCenter - firstCenter, 2);
//       if (
//         progress.style.left !== `${firstCenter}px` ||
//         progress.style.width !== `${newWidth}px`
//       ) {
//         progress.style.left = `${firstCenter}px`;
//         progress.style.width = `${newWidth}px`;
//       }
//     });
//   }, [yearIndex]);

//   useEffect(() => {
//     return () => {
//       if (rafId.current) cancelAnimationFrame(rafId.current);
//     };
//   }, []);


//   const scrollToActiveYear = useCallback(() => {
//     const container = yearLineRef.current;
//     const dot = yearDotsRef.current[yearIndex];
//     if (!container || !dot) return;

//     requestAnimationFrame(() => {
//       container.scrollTo({
//         left:
//           dot.offsetLeft -
//           container.offsetWidth / 2 +
//           dot.offsetWidth / 2,
//         behavior: "smooth",
//       });
//     });
//   }, [yearIndex]);

//   useEffect(() => {
//     scrollToActiveYear();
//     updateProgressBar();
//   }, [yearIndex]);

//   useEffect(() => {
//     updateProgressBar();
//   }, [width]);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         timeLineDetailSliderRef.current &&
//         !timeLineDetailSliderRef.current.contains(e.target)
//       ) {
//         closeDetailSlider();
//       }
//     };

//     if (showDetailSlider) {
//       document.addEventListener("mousedown", handleClickOutside);
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       document.body.style.overflow = "auto";
//     };
//   }, [showDetailSlider]);

//   const handleReadMore = (card) => {
//     dispatch(findCoreInitiativeById(card.id));
//     setSelectedCard(card);
//     setShowDetailSlider(true);
//   };

//   const closeDetailSlider = () => {
//     setShowDetailSlider(false);
//     setSelectedCard(null);
//   };

//   const nextCard = () => {
//     if (cardIndex < cards.length - 1) {
//       setCardIndex((p) => p + 1);
//     } else if (monthIndex < year.months.length - 1) {
//       setMonthIndex((p) => p + 1);
//       setCardIndex(0);
//     } else if (yearIndex < data.length - 1) {
//       setYearIndex((p) => p + 1);
//       setMonthIndex(0);
//       setCardIndex(0);
//     }
//   };

//   const prevCard = () => {
//     if (cardIndex > 0) {
//       setCardIndex((p) => p - 1);
//     } else if (monthIndex > 0) {
//       setMonthIndex((p) => p - 1);
//       setCardIndex(year.months[monthIndex - 1].cards.length - 1);
//     } else if (yearIndex > 0) {
//       const prevYear = data[yearIndex - 1];
//       setYearIndex((p) => p - 1);
//       setMonthIndex(prevYear.months.length - 1);
//       setCardIndex(
//         prevYear.months[prevYear.months.length - 1].cards.length - 1
//       );
//     }
//   };

//   const handleYearClick = useCallback((i) => {
//     setYearIndex(i);
//     setMonthIndex(0);
//     setCardIndex(0);
//   }, []);

//   const handleMonthClick = useCallback((i) => {
//     setMonthIndex(i);
//     setCardIndex(0);
//   }, []);

//   return (
//     <div className="timeline-bg">
//       <div className="customcontainer">
//         <h2 className="ourTeam-title">Core Initiative</h2>
//         <div className="year-line-wrapper">
//           <div className="year-progress-track">
//             <div className="year-progress-fill" ref={progressRef} />
//           </div>

//           <div className="year-line" ref={yearLineRef}>
//             {data.map((y, i) => (
//               <div
//                 key={y.year}
//                 ref={(el) => (yearDotsRef.current[i] = el)}
//                 className={`year-dot ${i === yearIndex ? "active" : ""
//                   }`}
//                 onClick={() => handleYearClick(i)}
//               >
//                 <span>{y.year}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="month-line-wrapper">
//           <div className="month-line">
//             {year.months.map((m, i) => (
//               <button
//                 key={m.month}
//                 className={i === monthIndex ? "active" : ""}
//                 onClick={() => handleMonthClick(i)}
//               >
//                 {m.month}
//               </button>
//             ))}
//           </div>
//         </div>
//         <div className="timeline-stage">
//           <button className="nav left" onClick={prevCard}>
//             <ChevronLeft />
//           </button>

//           <div className="active-card">
//             <div className="active-image">
//               <div className="active-image-video">
//                 {(() => {
//                   const source = isMobile
//                     ? card.mobileBanner
//                     : card.banner;

//                   if (source?.video?.url) {
//                     return (
//                       <video
//                         src={source.video.url}
//                         autoPlay
//                         muted
//                         loop
//                         playsInline
//                         controls
//                         className="detail-video"
//                       />
//                     );
//                   }
//                   if (source?.image?.url) {
//                     return (
//                       <img
//                         src={source.image.url}
//                         alt={card.title}
//                         className="detail-image"
//                       />
//                     );
//                   }
//                   return (
//                     <div className="no-media-placeholder">
//                       No media
//                     </div>
//                   );
//                 })()}
//               </div>
//             </div>

//             <div className="active-content">
//               <h3>{card.title}</h3>
//               <p>{card.description}</p>
//               <button
//                 className="timeLineCard-readMoreBtn"
//                 onClick={() => handleReadMore(card)}
//               >
//                 Read More →
//               </button>
//             </div>
//           </div>

//           <button className="nav right" onClick={nextCard}>
//             <ChevronRight />
//           </button>
//         </div>
//       </div>

//       {showDetailSlider && selectedCard && (
//         <div className="timeLineDetailOverlay">
//           <div
//             className="timeLineDetailSlider"
//             ref={timeLineDetailSliderRef}
//           >
//             <div className="timeLineDetailHeader">
//               <h2>{selectedCard.title}</h2>
//               <button
//                 className="timeLineDetailCloseBtn"
//                 onClick={closeDetailSlider}
//                 type="button"
//               >
//                 <X size={24} />
//               </button>


//             </div>

//             <div className="timeLineDetailBody">
//               <div className="main-event-image">
//                 {(() => {
//                   const source = isMobile
//                     ? selectedCard.mobileBanner
//                     : selectedCard.banner;
//                   const hasVideo = source?.video?.url;
//                   const hasImage = source?.image?.url;

//                   if (hasVideo) {
//                     return (
//                       <video
//                         src={hasVideo}
//                         autoPlay
//                         muted
//                         loop
//                         playsInline
//                         controls
//                         preload="metadata"
//                         className="detail-video"
//                       >
//                         <source src={hasVideo} type="video/mp4" />
//                         Your browser does not support the video tag.
//                       </video>
//                     );
//                   } else if (hasImage) {
//                     return (
//                       <img
//                         src={hasImage}
//                         alt={selectedCard.title}
//                         className="detail-image"
//                         loading="lazy"
//                       />
//                     );
//                   } else {
//                     return (
//                       <div className="no-media-placeholder">
//                         No media available
//                       </div>
//                     );
//                   }
//                 })()}
//               </div>

//               <div className="timeLineDetailDescription">
//                 <h3>About This Initiative</h3>
//                 <p>{coreInitiativeDetail?.longDescription}</p>
//               </div>

//               <div className="timeLineDetailGallery">
//                 <h4>Photo Gallery</h4>
//                 <div className="timeLineDetailGalleryGrid">
//                   {coreInitiativeDetail?.relatedMedia?.length > 0 ? (
//                     coreInitiativeDetail?.relatedMedia?.map((media, index) => (
//                       <div
//                         key={index}
//                         className="timeLineDetailGalleryItem"
//                       >
//                         {media.type === "image" && (
//                           <img
//                             src={media?.url}
//                             alt={`Media ${index + 1}`}
//                             loading="lazy"
//                           />
//                         )}
//                         {media.type === "video" && (
//                           <video
//                             controls
//                             preload="metadata"
//                             className="gallery-video"
//                           >
//                             <source src={media?.url} type="video/mp4" />
//                           </video>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     selectedCard.image && (
//                       <img
//                         src={selectedCard?.image}
//                         alt="Default"
//                         loading="lazy"
//                       />
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// import { useState, useRef, useEffect, useCallback } from "react";
// import { ChevronLeft, ChevronRight, X } from "lucide-react";
// import "./css/TempFun.css";
// import { findCoreInitiativeById } from "../features/PublicAPIsService";
// import { useDispatch, useSelector } from "react-redux";

// function useDebouncedResize(debounceTime = 150) {
//   const [windowSize, setWindowSize] = useState({
//     width: typeof window !== "undefined" ? window.innerWidth : 1200,
//     height: typeof window !== "undefined" ? window.innerHeight : 800,
//   });

//   useEffect(() => {
//     let timeoutId;

//     const handleResize = () => {
//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(() => {
//         if (window) {
//           setWindowSize({
//             width: window?.innerWidth || 1200,
//             height: window?.innerHeight || 800,
//           });
//         }
//       }, debounceTime);
//     };

//     if (window) {
//       window.addEventListener("resize", handleResize, { passive: true });
//     }

//     return () => {
//       if (window) {
//         window.removeEventListener("resize", handleResize);
//       }
//       if (timeoutId) {
//         clearTimeout(timeoutId);
//       }
//     };
//   }, [debounceTime]);

//   return windowSize;
// }

// export default function TempFun({ data }) {
//   const dispatch = useDispatch();

//   const [yearIndex, setYearIndex] = useState(0);
//   const [monthIndex, setMonthIndex] = useState(0);
//   const [cardIndex, setCardIndex] = useState(0);
//   const [selectedCard, setSelectedCard] = useState(null);
//   const [showDetailSlider, setShowDetailSlider] = useState(false);

//   const { coreInitiativeDetail } = useSelector(
//     (state) => (state && state.PublicAPIsService) || {}
//   );

//   const { width } = useDebouncedResize(200);
//   const isMobile = width < 768;

//   const yearLineRef = useRef(null);
//   const yearDotsRef = useRef([]);
//   const progressRef = useRef(null);
//   const timeLineDetailSliderRef = useRef(null);

//   const rafId = useRef(null);

//   const year = data && data[yearIndex];
//   const month = year && year.months && year.months[monthIndex];
//   const cards = month && month.cards;
//   const card = cards && cards[cardIndex];
  
//   const updateProgressBar = useCallback(() => {
//     if (rafId.current) {
//       cancelAnimationFrame(rafId.current);
//     }

//     rafId.current = requestAnimationFrame(() => {
//       const dots = yearDotsRef.current || [];
//       const progress = progressRef.current;
//       const track = progress?.parentElement;

//       if (!dots.length || !progress || !track) {
//         return;
//       }

//       const first = dots[0];
//       const active = dots[yearIndex];
//       if (!first || !active) {
//         return;
//       }

//       const firstRect = first.getBoundingClientRect && first.getBoundingClientRect();
//       const activeRect = active.getBoundingClientRect && active.getBoundingClientRect();
//       const trackRect = track.getBoundingClientRect && track.getBoundingClientRect();

//       if (!firstRect || !activeRect || !trackRect) {
//         return;
//       }

//       const firstCenter =
//         firstRect.left + firstRect.width / 2 - trackRect.left;

//       const activeCenter =
//         activeRect.left + activeRect.width / 2 - trackRect.left;

//       const newWidth = Math.max(activeCenter - firstCenter, 2);
//       if (progress?.style) {
//         if (progress.style.left !== `${firstCenter}px`) {
//           progress.style.left = `${firstCenter}px`;
//         }
//         if (progress.style.width !== `${newWidth}px`) {
//           progress.style.width = `${newWidth}px`;
//         }
//       }
//     });
//   }, [yearIndex]);

//   useEffect(() => {
//     return () => {
//       if (rafId.current) {
//         cancelAnimationFrame(rafId.current);
//       }
//     };
//   }, []);

//   const scrollToActiveYear = useCallback(() => {
//     const container = yearLineRef.current;
//     const dot = yearDotsRef.current && yearDotsRef.current[yearIndex];
//     if (!container || !dot) {
//       return;
//     }

//     requestAnimationFrame(() => {
//       if (container?.scrollTo && container?.offsetWidth && dot?.offsetLeft && dot?.offsetWidth) {
//         container.scrollTo({
//           left:
//             dot.offsetLeft -
//             container.offsetWidth / 2 +
//             dot.offsetWidth / 2,
//           behavior: "smooth",
//         });
//       }
//     });
//   }, [yearIndex]);

//   useEffect(() => {
//     scrollToActiveYear();
//     updateProgressBar();
//   }, [yearIndex, scrollToActiveYear, updateProgressBar]);

//   useEffect(() => {
//     updateProgressBar();
//   }, [width, updateProgressBar]);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         timeLineDetailSliderRef.current &&
//         e?.target &&
//         !timeLineDetailSliderRef.current.contains(e.target)
//       ) {
//         closeDetailSlider();
//       }
//     };

//     if (showDetailSlider) {
//       if (document) {
//         document.addEventListener("mousedown", handleClickOutside);
//         if (document.body) {
//           document.body.style.overflow = "hidden";
//         }
//       }
//     } else {
//       if (document?.body) {
//         document.body.style.overflow = "auto";
//       }
//     }

//     return () => {
//       if (document) {
//         document.removeEventListener("mousedown", handleClickOutside);
//       }
//       if (document?.body) {
//         document.body.style.overflow = "auto";
//       }
//     };
//   }, [showDetailSlider]);

//   const handleReadMore = (card) => {
//     if (card?.id) {
//       dispatch(findCoreInitiativeById(card.id));
//     }
//     setSelectedCard(card);
//     setShowDetailSlider(true);
//   };

//   const closeDetailSlider = () => {
//     setShowDetailSlider(false);
//     setSelectedCard(null);
//   };

//   const nextCard = () => {
//     if (cards && cardIndex < cards.length - 1) {
//       setCardIndex((p) => p + 1);
//     } else if (year?.months && monthIndex < year.months.length - 1) {
//       setMonthIndex((p) => p + 1);
//       setCardIndex(0);
//     } else if (data && yearIndex < data.length - 1) {
//       setYearIndex((p) => p + 1);
//       setMonthIndex(0);
//       setCardIndex(0);
//     }
//   };

//   const prevCard = () => {
//     if (cardIndex > 0) {
//       setCardIndex((p) => p - 1);
//     } else if (monthIndex > 0 && year?.months) {
//       setMonthIndex((p) => p - 1);
//       const prevMonthCards = year.months[monthIndex - 1]?.cards;
//       setCardIndex(prevMonthCards ? prevMonthCards.length - 1 : 0);
//     } else if (yearIndex > 0 && data) {
//       const prevYear = data[yearIndex - 1];
//       if (prevYear) {
//         setYearIndex((p) => p - 1);
//         const prevYearMonths = prevYear.months;
//         if (prevYearMonths) {
//           setMonthIndex(prevYearMonths.length - 1);
//           const lastMonthCards = prevYearMonths[prevYearMonths.length - 1]?.cards;
//           setCardIndex(lastMonthCards ? lastMonthCards.length - 1 : 0);
//         } else {
//           setMonthIndex(0);
//           setCardIndex(0);
//         }
//       }
//     }
//   };

//   const handleYearClick = useCallback((i) => {
//     setYearIndex(i);
//     setMonthIndex(0);
//     setCardIndex(0);
//   }, []);

//   const handleMonthClick = useCallback((i) => {
//     setMonthIndex(i);
//     setCardIndex(0);
//   }, []);

//   // Early return if no data
//   if (!data || !Array.isArray(data) || data.length === 0) {
//     return (
//       <div className="timeline-bg">
//         <div className="customcontainer">
//           <h2 className="ourTeam-title">Core Initiative</h2>
//           <div>No data available</div>
//         </div>
//       </div>
//     );
//   }

//   // Early return if year or month data is missing
//   if (!year || !month || !cards || !card) {
//     return (
//       <div className="timeline-bg">
//         <div className="customcontainer">
//           <h2 className="ourTeam-title">Core Initiative</h2>
//           <div>Data incomplete</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="timeline-bg">
//       <div className="customcontainer">
//         <h2 className="ourTeam-title">Core Initiative</h2>
//         <div className="year-line-wrapper">
//           <div className="year-progress-track">
//             <div className="year-progress-fill" ref={progressRef} />
//           </div>

//           <div className="year-line" ref={yearLineRef}>
//             {data.map((y, i) => (
//               <div
//                 key={y?.year || i}
//                 ref={(el) => {
//                   if (el && yearDotsRef.current) {
//                     yearDotsRef.current[i] = el;
//                   }
//                 }}
//                 className={`year-dot ${i === yearIndex ? "active" : ""
//                   }`}
//                 onClick={() => handleYearClick(i)}
//               >
//                 <span>{y?.year || ""}</span>
//               </div>
//             ))}
//           </div>
//         </div>
        
//         {year?.months && Array.isArray(year.months) && (
//           <div className="month-line-wrapper">
//             <div className="month-line">
//               {year.months.map((m, i) => (
//                 <button
//                   key={m?.month || i}
//                   className={i === monthIndex ? "active" : ""}
//                   onClick={() => handleMonthClick(i)}
//                 >
//                   {m?.month || ""}
//                 </button>
//               ))}
//             </div>
//           </div>
//         )}
        
//         <div className="timeline-stage">
//           <button className="nav left" onClick={prevCard}>
//             <ChevronLeft />
//           </button>

//           <div className="active-card">
//             <div className="active-image">
//               <div className="active-image-video">
//                 {(() => {
//                   if (!card) {
//                     return (
//                       <div className="no-media-placeholder">
//                         No card data
//                       </div>
//                     );
//                   }

//                   const source = isMobile
//                     ? card?.mobileBanner
//                     : card?.banner;

//                   if (source?.video?.url) {
//                     return (
//                       <video
//                         src={source.video.url}
//                         autoPlay
//                         muted
//                         loop
//                         playsInline
//                         controls
//                         className="detail-video"
//                       />
//                     );
//                   }
//                   if (source?.image?.url) {
//                     return (
//                       <img
//                         src={source.image.url}
//                         alt={card?.title || "Card image"}
//                         className="detail-image"
//                       />
//                     );
//                   }
//                   return (
//                     <div className="no-media-placeholder">
//                       No media
//                     </div>
//                   );
//                 })()}
//               </div>
//             </div>

//             <div className="active-content">
//               <h3>{card?.title || ""}</h3>
//               <p>{card?.description || ""}</p>
//               {card && (
//                 <button
//                   className="timeLineCard-readMoreBtn"
//                   onClick={() => handleReadMore(card)}
//                 >
//                   Read More →
//                 </button>
//               )}
//             </div>
//           </div>

//           <button className="nav right" onClick={nextCard}>
//             <ChevronRight />
//           </button>
//         </div>
//       </div>

//       {showDetailSlider && selectedCard && (
//         <div className="timeLineDetailOverlay">
//           <div
//             className="timeLineDetailSlider"
//             ref={timeLineDetailSliderRef}
//           >
//             <div className="timeLineDetailHeader">
//               <h2>{selectedCard?.title || ""}</h2>
//               <button
//                 className="timeLineDetailCloseBtn"
//                 onClick={closeDetailSlider}
//                 type="button"
//               >
//                 <X size={24} />
//               </button>
//             </div>

//             <div className="timeLineDetailBody">
//               <div className="main-event-image">
//                 {(() => {
//                   const source = isMobile
//                     ? selectedCard?.mobileBanner
//                     : selectedCard?.banner;
//                   const hasVideo = source?.video?.url;
//                   const hasImage = source?.image?.url;

//                   if (hasVideo) {
//                     return (
//                       <video
//                         src={hasVideo}
//                         autoPlay
//                         muted
//                         loop
//                         playsInline
//                         controls
//                         preload="metadata"
//                         className="detail-video"
//                       >
//                         <source src={hasVideo} type="video/mp4" />
//                         Your browser does not support the video tag.
//                       </video>
//                     );
//                   } else if (hasImage) {
//                     return (
//                       <img
//                         src={hasImage}
//                         alt={selectedCard?.title || "Detail image"}
//                         className="detail-image"
//                         loading="lazy"
//                       />
//                     );
//                   } else {
//                     return (
//                       <div className="no-media-placeholder">
//                         No media available
//                       </div>
//                     );
//                   }
//                 })()}
//               </div>

//               <div className="timeLineDetailDescription">
//                 <h3>About This Initiative</h3>
//                 <p>{coreInitiativeDetail?.longDescription || "No description available."}</p>
//               </div>

//               <div className="timeLineDetailGallery">
//                 <h4>Photo Gallery</h4>
//                 <div className="timeLineDetailGalleryGrid">
//                   {coreInitiativeDetail?.relatedMedia && 
//                    Array.isArray(coreInitiativeDetail.relatedMedia) && 
//                    coreInitiativeDetail.relatedMedia.length > 0 ? (
//                     coreInitiativeDetail.relatedMedia.map((media, index) => (
//                       <div
//                         key={index}
//                         className="timeLineDetailGalleryItem"
//                       >
//                         {media?.type === "image" && media?.url && (
//                           <img
//                             src={media.url}
//                             alt={`Media ${index + 1}`}
//                             loading="lazy"
//                           />
//                         )}
//                         {media?.type === "video" && media?.url && (
//                           <video
//                             controls
//                             preload="metadata"
//                             className="gallery-video"
//                           >
//                             <source src={media.url} type="video/mp4" />
//                           </video>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     selectedCard?.image && (
//                       <img
//                         src={selectedCard.image}
//                         alt="Default"
//                         loading="lazy"
//                       />
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import { useState, useRef, useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import "./css/TempFun.css";
import { findCoreInitiativeById } from "../features/PublicAPIsService";
import { useDispatch, useSelector } from "react-redux";

// Media selection logic function
const getBannerMedia = (item, isMobile) => {
  // For mobile view
  if (isMobile) {
    // First check mobile video
    if (item?.mobileBanner?.video?.url) {
      return {
        url: item.mobileBanner.video.url,
        type: "video",
        poster: item?.mobileBanner?.image?.url || item?.banner?.image?.url || null
      };
    }
    // If no mobile video, check mobile image
    else if (item?.mobileBanner?.image?.url) {
      return {
        url: item.mobileBanner.image.url,
        type: "image"
      };
    }
    // If no mobile media at all, fall back to desktop
  }

  // For desktop view OR mobile fallback
  // Check desktop video
  if (item?.banner?.video?.url) {
    return {
      url: item.banner.video.url,
      type: "video",
      poster: item?.banner?.image?.url || null
    };
  }
  // Check desktop image
  else if (item?.banner?.image?.url) {
    return {
      url: item.banner.image.url,
      type: "image"
    };
  }

  // If no media is available at all
  return null;
};

function useDebouncedResize(debounceTime = 150) {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 1200,
    height: typeof window !== "undefined" ? window.innerHeight : 800,
  });

  useEffect(() => {
    let timeoutId;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (window) {
          setWindowSize({
            width: window?.innerWidth || 1200,
            height: window?.innerHeight || 800,
          });
        }
      }, debounceTime);
    };

    if (window) {
      window.addEventListener("resize", handleResize, { passive: true });
    }

    return () => {
      if (window) {
        window.removeEventListener("resize", handleResize);
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [debounceTime]);

  return windowSize;
}

export default function TempFun({ data }) {
  const dispatch = useDispatch();

  const [yearIndex, setYearIndex] = useState(0);
  const [monthIndex, setMonthIndex] = useState(0);
  const [cardIndex, setCardIndex] = useState(0);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showDetailSlider, setShowDetailSlider] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState({});

  const { coreInitiativeDetail } = useSelector(
    (state) => (state && state.PublicAPIsService) || {}
  );

  const { width } = useDebouncedResize(200);
  const isMobile = width < 768;

  const yearLineRef = useRef(null);
  const yearDotsRef = useRef([]);
  const progressRef = useRef(null);
  const timeLineDetailSliderRef = useRef(null);

  const rafId = useRef(null);

  const year = data && data[yearIndex];
  const month = year && year.months && year.months[monthIndex];
  const cards = month && month.cards;
  const card = cards && cards[cardIndex];
  
  const handleVideoLoad = (id) => {
    setVideoLoaded(prev => ({ ...prev, [id]: true }));
  };

  const updateProgressBar = useCallback(() => {
    if (rafId.current) {
      cancelAnimationFrame(rafId.current);
    }

    rafId.current = requestAnimationFrame(() => {
      const dots = yearDotsRef.current || [];
      const progress = progressRef.current;
      const track = progress?.parentElement;

      if (!dots.length || !progress || !track) {
        return;
      }

      const first = dots[0];
      const active = dots[yearIndex];
      if (!first || !active) {
        return;
      }

      const firstRect = first.getBoundingClientRect && first.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect && active.getBoundingClientRect();
      const trackRect = track.getBoundingClientRect && track.getBoundingClientRect();

      if (!firstRect || !activeRect || !trackRect) {
        return;
      }

      const firstCenter =
        firstRect.left + firstRect.width / 2 - trackRect.left;

      const activeCenter =
        activeRect.left + activeRect.width / 2 - trackRect.left;

      const newWidth = Math.max(activeCenter - firstCenter, 2);
      if (progress?.style) {
        if (progress.style.left !== `${firstCenter}px`) {
          progress.style.left = `${firstCenter}px`;
        }
        if (progress.style.width !== `${newWidth}px`) {
          progress.style.width = `${newWidth}px`;
        }
      }
    });
  }, [yearIndex]);

  useEffect(() => {
    return () => {
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, []);

  const scrollToActiveYear = useCallback(() => {
    const container = yearLineRef.current;
    const dot = yearDotsRef.current && yearDotsRef.current[yearIndex];
    if (!container || !dot) {
      return;
    }

    requestAnimationFrame(() => {
      if (container?.scrollTo && container?.offsetWidth && dot?.offsetLeft && dot?.offsetWidth) {
        container.scrollTo({
          left:
            dot.offsetLeft -
            container.offsetWidth / 2 +
            dot.offsetWidth / 2,
          behavior: "smooth",
        });
      }
    });
  }, [yearIndex]);

  useEffect(() => {
    scrollToActiveYear();
    updateProgressBar();
  }, [yearIndex, scrollToActiveYear, updateProgressBar]);

  useEffect(() => {
    updateProgressBar();
  }, [width, updateProgressBar]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        timeLineDetailSliderRef.current &&
        e?.target &&
        !timeLineDetailSliderRef.current.contains(e.target)
      ) {
        closeDetailSlider();
      }
    };

    if (showDetailSlider) {
      if (document) {
        document.addEventListener("mousedown", handleClickOutside);
        if (document.body) {
          document.body.style.overflow = "hidden";
        }
      }
    } else {
      if (document?.body) {
        document.body.style.overflow = "auto";
      }
    }

    return () => {
      if (document) {
        document.removeEventListener("mousedown", handleClickOutside);
      }
      if (document?.body) {
        document.body.style.overflow = "auto";
      }
    };
  }, [showDetailSlider]);

  const handleReadMore = (card) => {
    if (card?.id) {
      dispatch(findCoreInitiativeById(card.id));
    }
    setSelectedCard(card);
    setShowDetailSlider(true);
  };

  const closeDetailSlider = () => {
    setShowDetailSlider(false);
    setSelectedCard(null);
  };

  const nextCard = () => {
    if (cards && cardIndex < cards.length - 1) {
      setCardIndex((p) => p + 1);
    } else if (year?.months && monthIndex < year.months.length - 1) {
      setMonthIndex((p) => p + 1);
      setCardIndex(0);
    } else if (data && yearIndex < data.length - 1) {
      setYearIndex((p) => p + 1);
      setMonthIndex(0);
      setCardIndex(0);
    }
  };

  const prevCard = () => {
    if (cardIndex > 0) {
      setCardIndex((p) => p - 1);
    } else if (monthIndex > 0 && year?.months) {
      setMonthIndex((p) => p - 1);
      const prevMonthCards = year.months[monthIndex - 1]?.cards;
      setCardIndex(prevMonthCards ? prevMonthCards.length - 1 : 0);
    } else if (yearIndex > 0 && data) {
      const prevYear = data[yearIndex - 1];
      if (prevYear) {
        setYearIndex((p) => p - 1);
        const prevYearMonths = prevYear.months;
        if (prevYearMonths) {
          setMonthIndex(prevYearMonths.length - 1);
          const lastMonthCards = prevYearMonths[prevYearMonths.length - 1]?.cards;
          setCardIndex(lastMonthCards ? lastMonthCards.length - 1 : 0);
        } else {
          setMonthIndex(0);
          setCardIndex(0);
        }
      }
    }
  };

  const handleYearClick = useCallback((i) => {
    setYearIndex(i);
    setMonthIndex(0);
    setCardIndex(0);
  }, []);

  const handleMonthClick = useCallback((i) => {
    setMonthIndex(i);
    setCardIndex(0);
  }, []);

  // Early return if no data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="timeline-bg">
        <div className="customcontainer">
          <h2 className="ourTeam-title">Core Initiative</h2>
          <div>No data available</div>
        </div>
      </div>
    );
  }

  // Early return if year or month data is missing
  if (!year || !month || !cards || !card) {
    return (
      <div className="timeline-bg">
        <div className="customcontainer">
          <h2 className="ourTeam-title">Core Initiative</h2>
          <div>Data incomplete</div>
        </div>
      </div>
    );
  }

  // Get media for active card
  const activeCardMedia = getBannerMedia(card, isMobile);
  
  // Get media for selected card in detail slider
  const selectedCardMedia = selectedCard ? getBannerMedia(selectedCard, isMobile) : null;

  return (
    <div className="timeline-bg">
      <div className="customcontainer">
        <h2 className="ourTeam-title">Core Initiative</h2>
        <div className="year-line-wrapper">
          <div className="year-progress-track">
            <div className="year-progress-fill" ref={progressRef} />
          </div>

          <div className="year-line" ref={yearLineRef}>
            {data.map((y, i) => (
              <div
                key={y?.year || i}
                ref={(el) => {
                  if (el && yearDotsRef.current) {
                    yearDotsRef.current[i] = el;
                  }
                }}
                className={`year-dot ${i === yearIndex ? "active" : ""
                  }`}
                onClick={() => handleYearClick(i)}
              >
                <span>{y?.year || ""}</span>
              </div>
            ))}
          </div>
        </div>
        
        {year?.months && Array.isArray(year.months) && (
          <div className="month-line-wrapper">
            <div className="month-line">
              {year.months.map((m, i) => (
                <button
                  key={m?.month || i}
                  className={i === monthIndex ? "active" : ""}
                  onClick={() => handleMonthClick(i)}
                >
                  {m?.month || ""}
                </button>
              ))}
            </div>
          </div>
        )}
        
        <div className="timeline-stage">
          <button className="nav left" onClick={prevCard}>
            <ChevronLeft />
          </button>

          <div className="active-card">
            <div className="active-image">
              <div className="active-image-video">
                {!activeCardMedia ? (
                  <div className="no-media-placeholder">
                    No media available
                  </div>
                ) : activeCardMedia.type === "video" ? (
                  <>
                    {/* Show poster image until video loads */}
                    {!videoLoaded[`main-${card.id}`] && activeCardMedia.poster && (
                      <img 
                        src={activeCardMedia.poster} 
                        alt={card?.title || "Card poster"}
                        className="video-poster"
                      />
                    )}
                    <video
                      src={activeCardMedia.url}
                      autoPlay
                      muted
                      loop
                      playsInline
                      controls
                      onLoadedData={() => handleVideoLoad(`main-${card.id}`)}
                      poster={activeCardMedia.poster || undefined}
                      style={{
                        display: videoLoaded[`main-${card.id}`] ? 'block' : 'none'
                      }}
                      className="detail-video"
                    />
                  </>
                ) : (
                  <img
                    src={activeCardMedia.url}
                    alt={card?.title || "Card image"}
                    className="detail-image"
                  />
                )}
              </div>
            </div>

            <div className="active-content">
              <h3>{card?.title || ""}</h3>
              <p>{card?.description || ""}</p>
              {card && (
                <button
                  className="timeLineCard-readMoreBtn"
                  onClick={() => handleReadMore(card)}
                >
                  Read More →
                </button>
              )}
            </div>
          </div>

          <button className="nav right" onClick={nextCard}>
            <ChevronRight />
          </button>
        </div>
      </div>

      {showDetailSlider && selectedCard && (
        <div className="timeLineDetailOverlay">
          <div
            className="timeLineDetailSlider"
            ref={timeLineDetailSliderRef}
          >
            <div className="timeLineDetailHeader">
              <h2>{selectedCard?.title || ""}</h2>
              <button
                className="timeLineDetailCloseBtn"
                onClick={closeDetailSlider}
                type="button"
              >
                <X size={24} />
              </button>
            </div>

            <div className="timeLineDetailBody">
              <div className="main-event-image">
                {!selectedCardMedia ? (
                  <div className="no-media-placeholder">
                    No media available
                  </div>
                ) : selectedCardMedia.type === "video" ? (
                  <>
                    {/* Show poster image until video loads */}
                    {!videoLoaded[`detail-${selectedCard.id}`] && selectedCardMedia.poster && (
                      <img 
                        src={selectedCardMedia.poster} 
                        alt={selectedCard?.title || "Detail poster"}
                        className="video-poster"
                      />
                    )}
                    <video
                      src={selectedCardMedia.url}
                      autoPlay
                      muted
                      loop
                      playsInline
                      controls
                      onLoadedData={() => handleVideoLoad(`detail-${selectedCard.id}`)}
                      poster={selectedCardMedia.poster || undefined}
                      style={{
                        display: videoLoaded[`detail-${selectedCard.id}`] ? 'block' : 'none'
                      }}
                      className="detail-video"
                    >
                      <source src={selectedCardMedia.url} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </>
                ) : (
                  <img
                    src={selectedCardMedia.url}
                    alt={selectedCard?.title || "Detail image"}
                    className="detail-image"
                    loading="lazy"
                  />
                )}
              </div>

              <div className="timeLineDetailDescription">
                <h3>About This Initiative</h3>
                <p>{coreInitiativeDetail?.longDescription || "No description available."}</p>
              </div>

              <div className="timeLineDetailGallery">
                <h4>Photo Gallery</h4>
                <div className="timeLineDetailGalleryGrid">
                  {coreInitiativeDetail?.relatedMedia && 
                   Array.isArray(coreInitiativeDetail.relatedMedia) && 
                   coreInitiativeDetail.relatedMedia.length > 0 ? (
                    coreInitiativeDetail.relatedMedia.map((media, index) => (
                      <div
                        key={index}
                        className="timeLineDetailGalleryItem"
                      >
                        {media?.type === "image" && media?.url && (
                          <img
                            src={media.url}
                            alt={`Media ${index + 1}`}
                            loading="lazy"
                          />
                        )}
                        {media?.type === "video" && media?.url && (
                          <video
                            controls
                            preload="metadata"
                            className="gallery-video"
                          >
                            <source src={media.url} type="video/mp4" />
                          </video>
                        )}
                      </div>
                    ))
                  ) : (
                    selectedCard?.image && (
                      <img
                        src={selectedCard.image}
                        alt="Default"
                        loading="lazy"
                      />
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}